type localesKeys__ContactPage = {
  contactPage__writeButton: string;
  contactPage__formTitle: string;
  contactPage__formName: string;
  contactPage__formCompany: string;
  contactPage__formOptional: string;
  contactPage__formEmail: string;
  contactPage__formMessage: string;
  contactPage__formSubmit: string;
  contactPage__formHint: string;
  contactPage__formClose: string;
  contactPage__mailSubject: string;
};

const ruLocale__ContactPage: localesKeys__ContactPage = {
  contactPage__writeButton: "Написать",
  contactPage__formTitle: "Написать мне",
  contactPage__formName: "Ваше имя",
  contactPage__formCompany: "Наименование вашей компании",
  contactPage__formOptional: "необязательно",
  contactPage__formEmail: "Email для ответа",
  contactPage__formMessage: "Сообщение",
  contactPage__formSubmit: "Отправить",
  contactPage__formHint: "Откроется ваш почтовый клиент с уже заполненным письмом",
  contactPage__formClose: "Закрыть",
  contactPage__mailSubject: "Сообщение с pvolobuev.ru",
};

const enLocale__ContactPage: localesKeys__ContactPage = {
  contactPage__writeButton: "Write me",
  contactPage__formTitle: "Write to me",
  contactPage__formName: "Your name",
  contactPage__formCompany: "Your company name",
  contactPage__formOptional: "optional",
  contactPage__formEmail: "Reply-to email",
  contactPage__formMessage: "Message",
  contactPage__formSubmit: "Send",
  contactPage__formHint: "Your email client will open with a pre-filled message",
  contactPage__formClose: "Close",
  contactPage__mailSubject: "Message from pvolobuev.ru",
};

export { ruLocale__ContactPage, enLocale__ContactPage };
export type { localesKeys__ContactPage };
